import { render } from "./Xperiod.vue?vue&type=template&id=4ba1a6d0"
import script from "./Xperiod.vue?vue&type=script&lang=js"
export * from "./Xperiod.vue?vue&type=script&lang=js"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__